import { bootstrapApplication } from '@angular/platform-browser';
import { RouteReuseStrategy, provideRouter, withPreloading, PreloadAllModules } from '@angular/router';
import { IonicRouteStrategy, provideIonicAngular } from '@ionic/angular/standalone';

import { routes } from './app/app.routes';
import { AppComponent } from './app/app.component';

import { environment } from './environments/environment';

import { initializeApp, provideFirebaseApp } from '@angular/fire/app';
import { getFirestore, provideFirestore } from '@angular/fire/firestore';
import { getAuth, provideAuth } from '@angular/fire/auth';
import { getStorage, provideStorage } from '@angular/fire/storage';
import { getFunctions, provideFunctions } from '@angular/fire/functions';

import {provideHttpClient, HttpClient} from '@angular/common/http';

import { LOCALE_ID } from '@angular/core';

import { registerLocaleData } from '@angular/common';
import localeEs from '@angular/common/locales/es';

//import { Capacitor } from '@capacitor/core';
//import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
//import { appConfig } from './app/app.config'; // Import your appConfig

registerLocaleData(localeEs, 'es-ES');


bootstrapApplication(AppComponent, {
  providers: [
    { provide: RouteReuseStrategy, useClass: IonicRouteStrategy },
    provideIonicAngular(),
    provideRouter(routes, withPreloading(PreloadAllModules)),
    provideFirebaseApp(() => initializeApp(environment.firebaseConfig)),
    provideFirestore(() => getFirestore()),
    provideAuth(() => getAuth()),
    provideStorage(() => getStorage()),
    //provideAnalytics(() => getAnalytics()),
    provideFunctions(() => getFunctions()),
    //provideMessaging(() => getMessaging()),
    //providePerformance(() => getPerformance()),
    provideHttpClient(),
    { provide: LOCALE_ID, useValue: 'es-ES' },
  ],
});

